import React, { useState, useEffect } from 'react';
import { Grid, Typography } from '@mui/material';

import { RestrictionBlock, StyledOl } from './Acknowledge.styles';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../redux/store';
import { getUserProfileAction } from '../../redux/slices/userProfile';
import { useNavigate } from 'react-router-dom';
import { LoginButton, LoginFormWrapper, TextWrapper } from './Login.styles';

const Acknowledge = () => {
  const [loading, setLoading] = useState<boolean>(false);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const token = useSelector((store: RootState) => store?.user?.tokens?.access);

  const handleAccept = (e: any) => {
    e.preventDefault();
    setLoading(true);
    dispatch(getUserProfileAction({ token: token!, navigate }));
  };

  useEffect(() => {
    const keyDownHandler = (e) => {
      if (e.key === 'Enter') {
        e.preventDefault();
        dispatch(getUserProfileAction({ token: token!, navigate }));
      }
    };

    document.addEventListener('keydown', keyDownHandler);

    return () => {
      document.removeEventListener('keydown', keyDownHandler);
    };
  }, []);

  return (
    <LoginFormWrapper onSubmit={handleAccept}>
      <TextWrapper>
        <Typography
          variant="dxs"
          color="#5B8AC5"
          component="p"
          fontWeight="600"
        >
          Terms of system usage
        </Typography>
      </TextWrapper>
      <RestrictionBlock>
        <Typography
          variant="tmd"
          color="#F9FAFB"
          component="p"
        >
          You are accessing a restricted information system.
        </Typography>
        <StyledOl>
          <li>
            System usage may be monitored, recorded, and subject to audit.
          </li>
          <li>
            Unauthorized use of the system is prohibited and may be subject to criminal and/or civil penalties.
          </li>
          <li>
            Use of the system indicates consent to monitoring and recording.
          </li>
          <li>
            Your credentials are for your sole use. Sharing credentials or using another
            user&apos;s credentials is prohibited and will result in permanent loss of access.
          </li>
        </StyledOl>
      </RestrictionBlock>
      <Grid width={'100%'} item xs={12}>
        <LoginButton
          color="primary"
          variant="contained"
          type="submit"
          loading={loading}
          fullWidth
        >
          Accept
        </LoginButton>
      </Grid>
    </LoginFormWrapper>
  );
};

export default Acknowledge;
